const URLContactForm = process.env.REACT_APP_SHARES_CONTACT_FORM;

class SharesContactFormService {
  async sendContactForm(firstName, lastName, email, phoneNumber) {
    return fetch(URLContactForm, {
      method: 'POST',
      body: JSON.stringify({ firstName, lastName, email, phoneNumber }),
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(res => (res.ok ? true : Promise.reject(res)));
  }
}

export default new SharesContactFormService();



// WEBPACK FOOTER //
// ./src/services/SharesContactForm.service.js